import { AuthRepository } from "../repositories/AuthRepository";

/**
 * Logout Use Case
 */
export class LogoutUseCase {
  constructor(private repository: AuthRepository) {}

  async execute(): Promise<void> {
    await this.repository.logout();
  }
}

